import { ValidateExhibitorResponse } from "view/SignUp/SignUpToken/context/types";

export type CredentialsSubmitAction = "validate" | "next" | "ignore";

/**
 * What pressing Next on the first step should do.
 *
 * The step avoids re-validating input it has already validated, which is why
 * an unchanged form normally just moves on. Two things override that:
 *
 * - `mustValidate`, set when a draft comes back from Google. The form and the
 *   stored values are then identical, so "nothing changed" is true while
 *   nothing has actually been checked — and the address has just been replaced
 *   by the Google one, which makes any earlier verdict about a different
 *   combination.
 * - a previous refusal, which must not be walked past by pressing Next again.
 * - no verdict at all: the last request failed (rate limit, outage), so the
 *   same input is sent again instead of skipping ahead unvalidated.
 */
export const resolveCredentialsSubmitAction = ({
  hasChanged,
  mustValidate,
  lastStatus,
}: {
  hasChanged: boolean;
  mustValidate: boolean;
  lastStatus?: ValidateExhibitorResponse["status"];
}): CredentialsSubmitAction => {
  if (hasChanged || mustValidate || !lastStatus) return "validate";
  if (lastStatus === "error") return "ignore";

  return "next";
};

export default resolveCredentialsSubmitAction;
